(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparacion-antes-despues"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-comparador-marco]').forEach(function (marco) {
  var control = marco.querySelector('[data-comparador-control]');
  var capaAntes = marco.querySelector('[data-comparador-capa-antes]');
  var imagenAntes = marco.querySelector('[data-comparador-imagen-antes]');
  var linea = marco.querySelector('[data-comparador-linea]');
  var manija = marco.querySelector('[data-comparador-manija]');
  if (!control || !capaAntes || !linea || !manija) {
    return;
  }

  function ajustarAncho() {
    if (imagenAntes) {
      var anchoMarco = marco.getBoundingClientRect().width;
      if (anchoMarco > 0) {
        imagenAntes.style.width = anchoMarco + 'px';
      }
    }
  }

  function actualizar() {
    var porcentaje = parseFloat(control.value);
    if (isNaN(porcentaje)) {
      porcentaje = 50;
    }
    capaAntes.style.width = porcentaje + '%';
    linea.style.left = porcentaje + '%';
    manija.style.left = porcentaje + '%';
  }

  control.addEventListener('input', actualizar);
  control.addEventListener('change', actualizar);
  window.addEventListener('resize', ajustarAncho);
  ajustarAncho();
  actualizar();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contra-reloj"] && !Shopify.designMode) return;
  try {
    
class CountdownOferta {
  constructor(raiz) {
    this.raiz = raiz;
    this.id = raiz.dataset.countdownOfertaId;
    this.modo = raiz.dataset.modo;
    this.horasDiarias = parseInt(raiz.dataset.horasDiarias, 10) || 0;
    this.minutosDiarios = parseInt(raiz.dataset.minutosDiarios, 10) || 0;
    this.fechaFin = raiz.dataset.fechaFin;
    this.mostrarDias = raiz.dataset.mostrarDias === 'true';
    this.elDias = raiz.querySelector('[data-countdown-oferta-dias]');
    this.elHoras = raiz.querySelector('[data-countdown-oferta-horas]');
    this.elMinutos = raiz.querySelector('[data-countdown-oferta-minutos]');
    this.elSegundos = raiz.querySelector('[data-countdown-oferta-segundos]');
    this.elReloj = raiz.querySelector('[data-countdown-oferta-reloj]');
    this.elFinalizado = raiz.querySelector('[data-countdown-oferta-finalizado]');
    this.claveAlmacenamiento = 'countdown-oferta-' + this.id;
    this.finTimestamp = this.calcularFin();
    this.intervalo = null;
    this.iniciar();
  }

  calcularFin() {
    if (this.modo === 'fecha_fija') {
      const fecha = new Date(this.fechaFin);
      return isNaN(fecha.getTime()) ? null : fecha.getTime();
    }
    const duracionMs = (this.horasDiarias * 3600 + this.minutosDiarios * 60) * 1000;
    if (duracionMs <= 0) return null;
    let guardado = null;
    try {
      guardado = window.localStorage.getItem(this.claveAlmacenamiento);
    } catch (error) {
      guardado = null;
    }
    const ahora = Date.now();
    if (guardado && parseInt(guardado, 10) > ahora) {
      return parseInt(guardado, 10);
    }
    const nuevoFin = ahora + duracionMs;
    try {
      window.localStorage.setItem(this.claveAlmacenamiento, String(nuevoFin));
    } catch (error) {}
    return nuevoFin;
  }

  formatear(numero) {
    return String(numero).padStart(2, '0');
  }

  actualizar() {
    if (this.finTimestamp === null) {
      this.mostrarFinalizado();
      return;
    }
    const restante = this.finTimestamp - Date.now();
    if (restante <= 0) {
      if (this.modo === 'diaria') {
        try {
          window.localStorage.removeItem(this.claveAlmacenamiento);
        } catch (error) {}
        this.finTimestamp = this.calcularFin();
        return;
      }
      this.mostrarFinalizado();
      return;
    }
    const segundosTotales = Math.floor(restante / 1000);
    const dias = Math.floor(segundosTotales / 86400);
    const horas = Math.floor((segundosTotales % 86400) / 3600);
    const minutos = Math.floor((segundosTotales % 3600) / 60);
    const segundos = segundosTotales % 60;
    if (this.elDias) this.elDias.textContent = this.formatear(dias);
    if (this.elHoras) this.elHoras.textContent = this.formatear(this.mostrarDias ? horas : horas + dias * 24);
    if (this.elMinutos) this.elMinutos.textContent = this.formatear(minutos);
    if (this.elSegundos) this.elSegundos.textContent = this.formatear(segundos);
  }

  mostrarFinalizado() {
    if (this.intervalo) clearInterval(this.intervalo);
    if (this.elReloj) this.elReloj.style.display = 'none';
    if (this.elFinalizado) this.elFinalizado.style.display = 'block';
  }

  iniciar() {
    this.actualizar();
    this.intervalo = setInterval(() => this.actualizar(), 1000);
  }
}

document.querySelectorAll('[data-countdown-oferta-id]').forEach((raiz) => {
  new CountdownOferta(raiz);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuenta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cot]:not([data-cot-listo])').forEach(function (raiz) {
  raiz.setAttribute('data-cot-listo', 'true');
  var modo = raiz.getAttribute('data-modo');
  var fechaFinTexto = raiz.getAttribute('data-fecha-fin');
  var duracionHoras = parseFloat(raiz.getAttribute('data-duracion-horas')) || 24;
  var reiniciar = raiz.getAttribute('data-reiniciar') === 'true';
  var ocultarExpirado = raiz.getAttribute('data-ocultar-expirado') === 'true';
  var clave = raiz.getAttribute('data-clave');
  var elDias = raiz.querySelector('[data-cot-dias]');
  var elHoras = raiz.querySelector('[data-cot-horas]');
  var elMinutos = raiz.querySelector('[data-cot-minutos]');
  var elSegundos = raiz.querySelector('[data-cot-segundos]');
  function dosDigitos(numero) {
    return numero < 10 ? '0' + numero : '' + numero;
  }
  function obtenerFechaObjetivo() {
    if (modo === 'fecha_fija' && fechaFinTexto) {
      var fecha = new Date(fechaFinTexto.replace(' ', 'T'));
      if (!isNaN(fecha.getTime())) {
        return fecha.getTime();
      }
    }
    var guardado = null;
    try {
      guardado = window.localStorage.getItem(clave);
    } catch (error) {
      guardado = null;
    }
    var ahora = new Date().getTime();
    if (guardado && parseInt(guardado, 10) > ahora) {
      return parseInt(guardado, 10);
    }
    var nuevoObjetivo = ahora + duracionHoras * 60 * 60 * 1000;
    try {
      window.localStorage.setItem(clave, nuevoObjetivo);
    } catch (error) {}
    return nuevoObjetivo;
  }
  var objetivo = obtenerFechaObjetivo();
  function actualizar() {
    var ahora = new Date().getTime();
    var restante = objetivo - ahora;
    if (restante <= 0) {
      if (modo === 'fecha_fija') {
        if (ocultarExpirado) {
          raiz.style.display = 'none';
          return;
        }
        elDias && (elDias.textContent = '00');
        elHoras.textContent = '00';
        elMinutos.textContent = '00';
        elSegundos.textContent = '00';
        return;
      }
      if (reiniciar) {
        try {
          window.localStorage.removeItem(clave);
        } catch (error) {}
        objetivo = obtenerFechaObjetivo();
        restante = objetivo - ahora;
      } else {
        elDias && (elDias.textContent = '00');
        elHoras.textContent = '00';
        elMinutos.textContent = '00';
        elSegundos.textContent = '00';
        return;
      }
    }
    var dias = Math.floor(restante / (1000 * 60 * 60 * 24));
    var horas = Math.floor((restante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutos = Math.floor((restante % (1000 * 60 * 60)) / (1000 * 60));
    var segundos = Math.floor((restante % (1000 * 60)) / 1000);
    if (elDias) {
      elDias.textContent = dosDigitos(dias);
    } else {
      horas += dias * 24;
    }
    elHoras.textContent = dosDigitos(horas);
    elMinutos.textContent = dosDigitos(minutos);
    elSegundos.textContent = dosDigitos(segundos);
  }
  actualizar();
  setInterval(actualizar, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preguntas-frecuentes"] && !Shopify.designMode) return;
  try {
    
class PreguntasFrecuentes {
  constructor(raiz) {
    this.raiz = raiz;
    this.multiples = raiz.dataset.multiples === 'true';
    this.items = Array.from(raiz.querySelectorAll('.preguntas-frecuentes-item'));
    this.items.forEach((item) => {
      const boton = item.querySelector('.preguntas-frecuentes-pregunta');
      if (!boton) return;
      boton.addEventListener('click', () => this.alternar(item));
    });
  }

  alternar(item) {
    const abierto = item.classList.contains('preguntas-frecuentes-item--abierto');
    if (!this.multiples) {
      this.items.forEach((otro) => {
        if (otro !== item) {
          otro.classList.remove('preguntas-frecuentes-item--abierto');
          const botonOtro = otro.querySelector('.preguntas-frecuentes-pregunta');
          if (botonOtro) botonOtro.setAttribute('aria-expanded', 'false');
        }
      });
    }
    item.classList.toggle('preguntas-frecuentes-item--abierto', !abierto);
    const boton = item.querySelector('.preguntas-frecuentes-pregunta');
    if (boton) boton.setAttribute('aria-expanded', String(!abierto));
  }
}

document.querySelectorAll('[data-preguntas-frecuentes-id]').forEach((raiz) => {
  new PreguntasFrecuentes(raiz);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preguntas"] && !Shopify.designMode) return;
  try {
    
class PreguntasFrecuentes {
  constructor(raiz) {
    this.raiz = raiz;
    this.multiples = raiz.dataset.multiples === 'true';
    this.items = Array.from(raiz.querySelectorAll('.preguntas-frecuentes-item'));
    this.items.forEach((item) => {
      const boton = item.querySelector('.preguntas-frecuentes-pregunta');
      if (!boton) return;
      boton.addEventListener('click', () => this.alternar(item));
    });
  }

  alternar(item) {
    const abierto = item.classList.contains('preguntas-frecuentes-item--abierto');
    if (!this.multiples) {
      this.items.forEach((otro) => {
        if (otro !== item) {
          otro.classList.remove('preguntas-frecuentes-item--abierto');
          const botonOtro = otro.querySelector('.preguntas-frecuentes-pregunta');
          if (botonOtro) botonOtro.setAttribute('aria-expanded', 'false');
        }
      });
    }
    item.classList.toggle('preguntas-frecuentes-item--abierto', !abierto);
    const boton = item.querySelector('.preguntas-frecuentes-pregunta');
    if (boton) boton.setAttribute('aria-expanded', String(!abierto));
  }
}

document.querySelectorAll('[data-preguntas-frecuentes-id]').forEach((raiz) => {
  new PreguntasFrecuentes(raiz);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-beneficios"] && !Shopify.designMode) return;
  try {
    
class ResenasBeneficiosCarrusel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.resenas-beneficios-track');
    if (!this.track) {
      return;
    }
    this.tarjetas = Array.prototype.slice.call(this.track.children);
    this.puntosContenedor = root.querySelector('[data-puntos]');
    this.indice = 0;
    this.inicioX = null;
    this.autoplayId = null;
    this.autoplayActivo = root.getAttribute('data-autoplay') === 'true';
    this.velocidadAutoplay = parseInt(root.getAttribute('data-velocidad-autoplay'), 10) || 5000;
    this.visiblesMovil = parseInt(root.getAttribute('data-visibles-movil'), 10) || 1;
    this.visiblesTablet = parseInt(root.getAttribute('data-visibles-tablet'), 10) || 2;
    this.visiblesEscritorio = parseInt(root.getAttribute('data-visibles-escritorio'), 10) || 2;
    this.bind();
    this.actualizar();
    if (this.autoplayActivo && this.tarjetas.length > 1) {
      this.iniciarAutoplay();
    }
  }

  bind() {
    var self = this;
    this.track.addEventListener('touchstart', function (evento) {
      self.inicioX = evento.touches[0].clientX;
    }, { passive: true });
    this.track.addEventListener('touchend', function (evento) {
      if (self.inicioX === null) {
        return;
      }
      var finX = evento.changedTouches[0].clientX;
      var diferencia = self.inicioX - finX;
      if (Math.abs(diferencia) > 40) {
        if (diferencia > 0) {
          self.siguiente();
        } else {
          self.anterior();
        }
      }
      self.inicioX = null;
    });
    var temporizador = null;
    window.addEventListener('resize', function () {
      clearTimeout(temporizador);
      temporizador = setTimeout(function () {
        self.actualizar();
      }, 200);
    });
  }

  obtenerVisibles() {
    var ancho = window.innerWidth;
    if (ancho >= 990) {
      return this.visiblesEscritorio;
    }
    if (ancho >= 749) {
      return this.visiblesTablet;
    }
    return this.visiblesMovil;
  }

  obtenerMaxIndice() {
    var visibles = this.obtenerVisibles();
    return Math.max(this.tarjetas.length - visibles, 0);
  }

  actualizar() {
    var visibles = this.obtenerVisibles();
    var ancho = 100 / visibles;
    this.tarjetas.forEach(function (tarjeta) {
      tarjeta.style.setProperty('flex', '0 0 ' + ancho + '%', 'important');
      tarjeta.style.setProperty('max-width', ancho + '%', 'important');
    });
    var maxIndice = this.obtenerMaxIndice();
    if (this.indice > maxIndice) {
      this.indice = maxIndice;
    }
    var estilosTrack = window.getComputedStyle(this.track);
    var gapPx = parseFloat(estilosTrack.columnGap || estilosTrack.gap) || 0;
    var desplazamientoPx = 0;
    for (var k = 0; k < this.indice; k++) {
      if (this.tarjetas[k]) {
        desplazamientoPx += this.tarjetas[k].getBoundingClientRect().width + gapPx;
      }
    }
    this.track.style.transform = 'translateX(-' + desplazamientoPx + 'px)';
    this.generarPuntos(maxIndice);
  }

  generarPuntos(maxIndice) {
    if (!this.puntosContenedor) {
      return;
    }
    if (this.puntosContenedor.childElementCount !== maxIndice + 1) {
      this.puntosContenedor.innerHTML = '';
      var self = this;
      var crearPunto = function (indice) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'resenas-beneficios-punto';
        punto.setAttribute('aria-label', 'Ir a la reseña ' + (indice + 1));
        punto.addEventListener('click', function () {
          self.irA(indice);
          self.reiniciarAutoplay();
        });
        return punto;
      };
      for (var i = 0; i <= maxIndice; i++) {
        this.puntosContenedor.appendChild(crearPunto(i));
      }
    }
    var puntos = this.puntosContenedor.children;
    for (var j = 0; j < puntos.length; j++) {
      if (j === this.indice) {
        puntos[j].classList.add('resenas-beneficios-punto--activo');
      } else {
        puntos[j].classList.remove('resenas-beneficios-punto--activo');
      }
    }
  }

  irA(indice) {
    var maxIndice = this.obtenerMaxIndice();
    this.indice = Math.min(Math.max(indice, 0), maxIndice);
    this.actualizar();
  }

  siguiente() {
    var maxIndice = this.obtenerMaxIndice();
    if (this.indice >= maxIndice) {
      this.irA(0);
    } else {
      this.irA(this.indice + 1);
    }
    this.reiniciarAutoplay();
  }

  anterior() {
    var maxIndice = this.obtenerMaxIndice();
    if (this.indice <= 0) {
      this.irA(maxIndice);
    } else {
      this.irA(this.indice - 1);
    }
    this.reiniciarAutoplay();
  }

  iniciarAutoplay() {
    var self = this;
    this.detenerAutoplay();
    this.autoplayId = setInterval(function () {
      self.siguiente();
    }, this.velocidadAutoplay);
  }

  detenerAutoplay() {
    if (this.autoplayId) {
      clearInterval(this.autoplayId);
      this.autoplayId = null;
    }
  }

  reiniciarAutoplay() {
    if (this.autoplayActivo) {
      this.iniciarAutoplay();
    }
  }
}

class ResenasBeneficiosAcordeon {
  constructor(root) {
    this.items = Array.prototype.slice.call(root.querySelectorAll('.resenas-beneficios-item'));
    this.items.forEach(function (item) {
      var boton = item.querySelector('[data-toggle-beneficio]');
      if (!boton) {
        return;
      }
      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('resenas-beneficios-item--abierto');
        item.classList.toggle('resenas-beneficios-item--abierto', !abierto);
        boton.setAttribute('aria-expanded', String(!abierto));
      });
    });
  }
}

function iniciarResenasBeneficios() {
  document.querySelectorAll('.resenas-beneficios-seccion').forEach(function (root) {
    if (!root.getAttribute('data-rb-init')) {
      root.setAttribute('data-rb-init', 'true');
      new ResenasBeneficiosCarrusel(root);
      new ResenasBeneficiosAcordeon(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', iniciarResenasBeneficios);
} else {
  iniciarResenasBeneficios();
}
document.addEventListener('shopify:section:load', iniciarResenasBeneficios);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-clientes"] && !Shopify.designMode) return;
  try {
    
class ResenasClientesCarrusel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.resenas-clientes-track');
    if (!this.track) {
      return;
    }
    this.tarjetas = Array.prototype.slice.call(this.track.children);
    this.flechaPrev = root.querySelector('[data-flecha-prev]');
    this.flechaNext = root.querySelector('[data-flecha-next]');
    this.puntosContenedor = root.querySelector('[data-puntos]');
    this.indice = 0;
    this.inicioX = null;
    this.autoplayId = null;
    this.autoplayActivo = root.getAttribute('data-autoplay') === 'true';
    this.velocidadAutoplay = parseInt(root.getAttribute('data-velocidad-autoplay'), 10) || 6000;
    this.visiblesMovil = parseInt(root.getAttribute('data-visibles-movil'), 10) || 1;
    this.visiblesTablet = parseInt(root.getAttribute('data-visibles-tablet'), 10) || 1;
    this.visiblesEscritorio = parseInt(root.getAttribute('data-visibles-escritorio'), 10) || 3;
    this.bind();
    this.actualizar();
    if (this.autoplayActivo && this.tarjetas.length > 1) {
      this.iniciarAutoplay();
    }
  }

  bind() {
    var self = this;
    if (this.flechaPrev) {
      this.flechaPrev.addEventListener('click', function () {
        self.anterior();
      });
    }
    if (this.flechaNext) {
      this.flechaNext.addEventListener('click', function () {
        self.siguiente();
      });
    }
    this.track.addEventListener('touchstart', function (evento) {
      self.inicioX = evento.touches[0].clientX;
    }, { passive: true });
    this.track.addEventListener('touchend', function (evento) {
      if (self.inicioX === null) {
        return;
      }
      var finX = evento.changedTouches[0].clientX;
      var diferencia = self.inicioX - finX;
      if (Math.abs(diferencia) > 40) {
        if (diferencia > 0) {
          self.siguiente();
        } else {
          self.anterior();
        }
      }
      self.inicioX = null;
    });
    var temporizador = null;
    window.addEventListener('resize', function () {
      clearTimeout(temporizador);
      temporizador = setTimeout(function () {
        self.actualizar();
      }, 200);
    });
  }

  obtenerVisibles() {
    var ancho = window.innerWidth;
    if (ancho >= 990) {
      return this.visiblesEscritorio;
    }
    if (ancho >= 749) {
      return this.visiblesTablet;
    }
    return this.visiblesMovil;
  }

  obtenerMaxIndice() {
    var visibles = this.obtenerVisibles();
    return Math.max(this.tarjetas.length - visibles, 0);
  }

  actualizar() {
    var visibles = this.obtenerVisibles();
    var ancho = 100 / visibles;
    this.tarjetas.forEach(function (tarjeta) {
      tarjeta.style.setProperty('flex', '0 0 ' + ancho + '%', 'important');
      tarjeta.style.setProperty('max-width', ancho + '%', 'important');
    });
    var maxIndice = this.obtenerMaxIndice();
    if (this.indice > maxIndice) {
      this.indice = maxIndice;
    }
    var estilosTrack = window.getComputedStyle(this.track);
    var gapPx = parseFloat(estilosTrack.columnGap || estilosTrack.gap) || 0;
    var desplazamientoPx = 0;
    for (var k = 0; k < this.indice; k++) {
      if (this.tarjetas[k]) {
        desplazamientoPx += this.tarjetas[k].getBoundingClientRect().width + gapPx;
      }
    }
    this.track.style.transform = 'translateX(-' + desplazamientoPx + 'px)';
    this.actualizarFlechas(maxIndice);
    this.generarPuntos(maxIndice);
  }

  actualizarFlechas(maxIndice) {
    if (this.flechaPrev) {
      this.flechaPrev.disabled = this.indice <= 0;
    }
    if (this.flechaNext) {
      this.flechaNext.disabled = this.indice >= maxIndice;
    }
  }

  generarPuntos(maxIndice) {
    if (!this.puntosContenedor) {
      return;
    }
    if (this.puntosContenedor.childElementCount !== maxIndice + 1) {
      this.puntosContenedor.innerHTML = '';
      var self = this;
      var crearPunto = function (indice) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'resenas-clientes-punto';
        punto.setAttribute('aria-label', 'Ir a la reseña ' + (indice + 1));
        punto.addEventListener('click', function () {
          self.irA(indice);
          self.reiniciarAutoplay();
        });
        return punto;
      };
      for (var i = 0; i <= maxIndice; i++) {
        this.puntosContenedor.appendChild(crearPunto(i));
      }
    }
    var puntos = this.puntosContenedor.children;
    for (var j = 0; j < puntos.length; j++) {
      if (j === this.indice) {
        puntos[j].classList.add('resenas-clientes-punto--activo');
      } else {
        puntos[j].classList.remove('resenas-clientes-punto--activo');
      }
    }
  }

  irA(indice) {
    var maxIndice = this.obtenerMaxIndice();
    this.indice = Math.min(Math.max(indice, 0), maxIndice);
    this.actualizar();
  }

  siguiente() {
    var maxIndice = this.obtenerMaxIndice();
    if (this.indice >= maxIndice) {
      this.irA(0);
    } else {
      this.irA(this.indice + 1);
    }
    this.reiniciarAutoplay();
  }

  anterior() {
    var maxIndice = this.obtenerMaxIndice();
    if (this.indice <= 0) {
      this.irA(maxIndice);
    } else {
      this.irA(this.indice - 1);
    }
    this.reiniciarAutoplay();
  }

  iniciarAutoplay() {
    var self = this;
    this.detenerAutoplay();
    this.autoplayId = setInterval(function () {
      self.siguiente();
    }, this.velocidadAutoplay);
  }

  detenerAutoplay() {
    if (this.autoplayId) {
      clearInterval(this.autoplayId);
      this.autoplayId = null;
    }
  }

  reiniciarAutoplay() {
    if (this.autoplayActivo) {
      this.iniciarAutoplay();
    }
  }
}

function iniciarResenasClientes() {
  document.querySelectorAll('.resenas-clientes-seccion').forEach(function (root) {
    if (!root.getAttribute('data-rc-init')) {
      root.setAttribute('data-rc-init', 'true');
      new ResenasClientesCarrusel(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', iniciarResenasClientes);
} else {
  iniciarResenasClientes();
}
document.addEventListener('shopify:section:load', iniciarResenasClientes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-genericas"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-boton-util]').forEach(function (boton) {
  boton.addEventListener('click', function () {
    var contador = boton.querySelector('[data-util-contador]');
    if (!contador || boton.getAttribute('data-votado') === 'true') {
      return;
    }
    var valor = parseInt(contador.textContent, 10) || 0;
    contador.textContent = valor + 1;
    boton.setAttribute('data-votado', 'true');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--logo-slider"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-logo-slider-section')){
  class StackLogoSliderSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.resizeTimeout = null;
      this.boundHandleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const marquee = this.querySelector('.stack--logo-slider-marquee');
      const tracksContainer = this.querySelector('.stack--logo-slider-tracks-container');
      
      if (!marquee || !tracksContainer) return;
      
      if (window.getComputedStyle(document.documentElement).getPropertyValue('direction') === 'rtl') {
        marquee.classList.add('stack--logo-slider-rtl');
      }
      
      this.adjustTrackCount(tracksContainer);
      
      // Setup resize listener
      window.addEventListener('resize', this.boundHandleResize);
      
      this.initialized = true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const tracksContainer = this.querySelector('.stack--logo-slider-tracks-container');
        if (tracksContainer) {
          this.adjustTrackCount(tracksContainer);
        }
      }, 250);
    }

    adjustTrackCount(tracksContainer) {
      const existingTracks = tracksContainer.querySelectorAll('.stack--logo-slider-track');
      const firstTrack = existingTracks[0];
      
      if (!firstTrack) return;
      
      const screenWidth = window.innerWidth;
      const trackWidth = firstTrack.scrollWidth;
      const neededTracks = Math.max(3, Math.ceil((screenWidth * 2) / trackWidth));
      const currentTracks = existingTracks.length;
      
      if (neededTracks > currentTracks) {
        for (let i = currentTracks; i < neededTracks; i++) {
          const newTrack = firstTrack.cloneNode(true);
          newTrack.setAttribute('aria-hidden', 'true');
          
          newTrack.querySelectorAll('.stack--logo-slider-item').forEach(item => {
            item.removeAttribute('data-block-id');
            item.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
            item.querySelectorAll('img').forEach(img => img.setAttribute('alt', ''));
          });
          
          tracksContainer.appendChild(newTrack);
        }
        this.resetAnimation(tracksContainer);
      }
      
      if (neededTracks < currentTracks) {
        for (let i = currentTracks - 1; i >= neededTracks; i--) {
          if (existingTracks[i] && i > 0) {
            existingTracks[i].remove();
          }
        }
        this.resetAnimation(tracksContainer);
      }
    }

    resetAnimation(tracksContainer) {
      const tracks = tracksContainer.querySelectorAll('.stack--logo-slider-track');
      tracks.forEach(track => {
        track.style.animation = 'none';
        track.offsetHeight;
        track.style.animation = null;
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundHandleResize);
      this.initialized = false;
    }
  }

  customElements.define('stack-logo-slider-section', StackLogoSliderSection);
}

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('stack--logo-slider')) {
      const section = document.querySelector('.stack--logo-slider');
      if (section && section.tagName.toLowerCase() === 'stack-logo-slider-section') {
        setTimeout(() => section.init(), 100);
      }
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    if (event.detail.sectionId.includes('stack--logo-slider')) {
      const section = document.querySelector('.stack--logo-slider');
      if (section && section.tagName.toLowerCase() === 'stack-logo-slider-section') {
        section.disconnectedCallback();
      }
    }
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--shoppable-slides"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-shoppable-slides-section')){
class StackShoppableSlidesSection extends HTMLElement {
constructor() {
super();
this.initialized = false;
this.swiper = null;
this.currentlyPlayingVideo = null;
}

connectedCallback() {
if(!window.stack?.isChecked||!window.stack.isChecked()){
setTimeout(()=>{
 if(!window.stack?.check||window.stack.check()===false){
   this.remove();
 } else {
   this.init();
 }
},100);
return;
}
if(!window.stack?.check||window.stack.check()===false){
this.remove();
return;
}
requestAnimationFrame(() => this.init());
}

init() {
if (this.initialized) return;

// Add initial load class for animation
if (this.classList.contains('stack--shoppable-slides-fade')) {
this.classList.add('stack--shoppable-slides-initial-load');
// Remove after animation completes
setTimeout(() => {
 this.classList.remove('stack--shoppable-slides-initial-load');
}, 1500);
}

this.initSwiperSlider();
this.initVideoControls();

this.initialized = true;
}

initSwiperSlider() {
const swiperContainer = this.querySelector('.stack--shoppable-slides-swiper');
if (!swiperContainer) return;

// Wait for Swiper library to load
if (typeof Swiper === 'undefined') {
setTimeout(() => this.initSwiperSlider(), 100);
return;
}

const autoplayEnabled = this.dataset.autoplay === 'true';
const coverflowEnabled = this.dataset.coverflow === 'true';
const swiperId = swiperContainer.id;

// Initialize Swiper configuration
const swiperConfig = {
grabCursor: true,
centeredSlides: true,
slidesPerView: 'auto',
spaceBetween: 20,
loop: true,
loopAddBlankSlides: true,
loopAdditionalSlides: 3,
speed: 600,

// Navigation (scoped to this specific swiper)
navigation: {
 nextEl: this.querySelector('.swiper-button-next'),
 prevEl: this.querySelector('.swiper-button-prev'),
},

// Autoplay (optional)
...(autoplayEnabled && {
 autoplay: {
   delay: 5000,
   disableOnInteraction: false,
   pauseOnMouseEnter: true,
 },
}),

// Coverflow effect (optional)
...(coverflowEnabled && {
 effect: 'coverflow',
 coverflowEffect: {
   rotate: 0,
   stretch: 0,
   depth: 85,
   modifier: 1,
   slideShadows: true,
 },
}),

// Accessibility
a11y: {
 enabled: true,
 prevSlideMessage: 'Previous video',
 nextSlideMessage: 'Next video',
 firstSlideMessage: 'This is the first video',
 lastSlideMessage: 'This is the last video',
},

// Keyboard control
keyboard: {
 enabled: true,
 onlyInViewport: true,
},

// Responsive breakpoints
breakpoints: {
 1024: {
   spaceBetween: 50,
 },
 768: {
  spaceBetween: 40,
 }
},

// Prevent animation on init
runCallbacksOnInit: false,

// On slide change, stop all videos
on: {
 slideChange: () => {
   this.stopAllVideos();
 },
},
};

// Initialize Swiper with unique ID
this.swiper = new Swiper(`#${swiperId}`, swiperConfig);
}

initVideoControls() {
const slides = this.querySelectorAll('.swiper-slide');

slides.forEach((slide) => {
 const video = slide.querySelector('.stack--shoppable-slides-video');
 const playButton = slide.querySelector('.stack--shoppable-slides-play-button');
 const playIcon = slide.querySelector('#iconPlay');
 const pauseIcon = slide.querySelector('#iconPause');

 if (!video || !playButton || !playIcon || !pauseIcon) return;

 // Play/Pause on button click
 playButton.addEventListener('click', (e) => {
   e.stopPropagation();
   
   // Only allow interaction on active, prev, or next slides
   if (
     slide.classList.contains('swiper-slide-active') ||
     slide.classList.contains('swiper-slide-next') ||
     slide.classList.contains('swiper-slide-prev')
   ) {
     // Stop other videos first
     if (this.currentlyPlayingVideo && this.currentlyPlayingVideo !== video) {
       this.stopVideo(this.currentlyPlayingVideo);
     }

     // Toggle current video
     if (video.paused) {
       video.volume = 0.4;
       video.play();
       playIcon.style.display = 'none';
       pauseIcon.style.display = 'block';
       playButton.setAttribute('aria-label', 'Pause video');
       this.currentlyPlayingVideo = video;
     } else {
       this.stopVideo(video);
     }
   }
 });

 // Reset video when it ends
 video.addEventListener('ended', () => {
   video.currentTime = 0;
   playIcon.style.display = 'block';
   pauseIcon.style.display = 'none';
   playButton.setAttribute('aria-label', 'Play video');
   if (this.currentlyPlayingVideo === video) {
     this.currentlyPlayingVideo = null;
   }
 });
});
}

stopVideo(video) {
if (!video) return;

const slide = video.closest('.swiper-slide');
if (!slide) return;

const playIcon = slide.querySelector('#iconPlay');
const pauseIcon = slide.querySelector('#iconPause');
const playButton = slide.querySelector('.stack--shoppable-slides-play-button');

video.pause();
if (playIcon) playIcon.style.display = 'block';
if (pauseIcon) pauseIcon.style.display = 'none';
if (playButton) playButton.setAttribute('aria-label', 'Play video');

if (this.currentlyPlayingVideo === video) {
 this.currentlyPlayingVideo = null;
}
}

stopAllVideos() {
const videos = this.querySelectorAll('.stack--shoppable-slides-video');
videos.forEach(video => this.stopVideo(video));
}

disconnectedCallback() {
// Cleanup Swiper instance
if (this.swiper && this.swiper.destroy) {
this.swiper.destroy(true, true);
}
this.stopAllVideos();
this.initialized = false;
}
}

customElements.define('stack-shoppable-slides-section', StackShoppableSlidesSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
setTimeout(() => section.init(), 100);
}
}
});

document.addEventListener('shopify:section:select', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
section.init();
}
}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--testimonials"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-testimonials-section')){
  class StackTestimonialsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.swiper = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const layout = this.dataset.layout;
      
      if (layout === 'stack') {
        this.initStackViewMore();
      } else if (layout === 'slider') {
        this.initSwiperSlider();
      }

      this.initialized = true;
    }

    initStackViewMore() {
      const viewMoreBtn = this.querySelector('.stack--testimonials-view-more-btn');
      if (!viewMoreBtn) return;
      
      viewMoreBtn.addEventListener('click', () => {
        const hiddenCards = this.querySelectorAll('.stack--testimonials-card-hidden');
        hiddenCards.forEach(card => {
          card.classList.remove('stack--testimonials-card-hidden');
        });
        viewMoreBtn.parentElement.style.display = 'none';
      });
    }

    initSwiperSlider() {
      const swiperContainer = this.querySelector('.stack--testimonials-swiper');
      if (!swiperContainer) return;
      
      // Wait for Swiper library to load
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initSwiperSlider(), 100);
        return;
      }
      
      // Initialize Swiper with configuration
      this.swiper = new Swiper('.stack--testimonials-swiper', {
        // Basic settings
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 600,
        // Navigation
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        centeredSlides: false,
        slidesPerView: 'auto',
        
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous testimonial',
          nextSlideMessage: 'Next testimonial',
          firstSlideMessage: 'This is the first testimonial',
          lastSlideMessage: 'This is the last testimonial',
        },
        
        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        
        // Touch/Swipe
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        touchStartPreventDefault: false,
        
        // Effects
        effect: 'slide',
        fadeEffect: {
          crossFade: true,
        },
      });
    }

    disconnectedCallback() {
      // Cleanup Swiper instance
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-testimonials-section', StackTestimonialsSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      section.init();
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();
})();
